export default __webpack_public_path__ + "static/media/DOG_NOISE.af653981.wav";